import styled from 'styled-components'
import Icon from './Icon'

const CloseIcon = styled(Icon).attrs({
  type: 'x',
})``

export default CloseIcon
